import { DatasetResult, DatasetDetails } from '@mode/shared/contract-common';
import { SwitchView } from '@mode/shared/contract-common';

export interface Dataset {
  token: string;
  result: DatasetResult;
  switchView: SwitchView;
  details?: DatasetDetails;
}

export abstract class PublishDialogService {
  public abstract open(switchViewToken: string): void;
}

export abstract class RepublishDialogService {
  public abstract open(switchViewToken: string, queryToken?: string, selectedText?: string): void;
}

export abstract class UnpublishDialogService {
  public abstract open(switchViewToken: string): void;
}

export abstract class PromoteQueryToDatasetDialogService {
  public abstract open(switchViewToken: string): void;
}

export abstract class MoveSpaceDialogService {
  public abstract open(switchViewToken: string): void;
}

export enum PublishOption {
  Publish = 'Publish',
  Unpublish = 'Unpublish',
}

export type PublishState = PublishOption | null;

export enum DatasetPublishingFlagStates {
  ENABLED = 'ENABLED',
  ENABLED_ALPHA = 'ENABLED_ALPHA',
  DISABLED = 'DISABLED',
}

export enum PublishDatasetEvents {
  TsSubmitted = 'ts_submitted',
  NuggetSubmitted = 'nugget_submitted',
  PublishDatasetFailed = 'publish_dataset_failed',
  PublishDatasetSuccess = 'publish_dataset_success',
}

export interface DatasetPublicationStatusToastPayload {
  status: 'error' | 'processing' | 'success';
  heading?: string;
  text?: string;
  cta?: string;
  ctaLink?: string;
  showDismissCta?: boolean;
  showCloseBtn?: boolean;
}

export interface PublishDatasetSocketSuccessPayload {
  token: string;
  message: string;
  state: string;
  thoughtspot_publish_url: string;
  thoughtspot_published_at: string;
  publish_to_thoughtspot_succeeded_at: string;
}

export interface PromoteQueryToDatasetResponse {
  dataset_token: string;
  _links: {
    dataset_report_page_view: {
      href: string;
    };
  };
}
